import { useQuery } from '@tanstack/react-query';

import {
  getV1SubscriptionsOptions,
  getV1TaxonomyOptions,
} from '../../../api/generated/notification-pref/@tanstack/react-query.gen';

/**
 * Query hooks for the Notification Preferences feature.
 *
 * Thin wrappers over the generated `@hey-api` react-query options (see AGENTS.md
 * colocated hooks pattern).
 */

export const useTaxonomy = () => useQuery(getV1TaxonomyOptions());

export const useSubscriptions = (aspect: 'user' | 'identity' | undefined) =>
  useQuery(
    getV1SubscriptionsOptions({ query: { aspect: aspect as 'user' | 'identity' | undefined } })
  );
